module.exports = __webpack_public_path__ + "img/13b)(Arabella Sheraton Hotel in München)Montage der über 500 Gästezimmer.jpg";